/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type { ReaderFragment } from 'relay-runtime';
import type { FragmentReference } from "relay-runtime";
declare export opaque type PGARecentHistoryTable_query$ref: FragmentReference;
declare export opaque type PGARecentHistoryTable_query$fragmentType: PGARecentHistoryTable_query$ref;
export type PGARecentHistoryTable_query = {|
  +pgaRecentHistoryForDkPlayer: ?{|
    +edges: $ReadOnlyArray<?{|
      +node: ?{|
        +id: string,
        +strokesGainedApproachTheGreen: ?any,
        +strokesGainedAroundTheGreen: ?any,
        +strokesGainedBallStriking: ?any,
        +strokesGainedIronPlay: ?any,
        +strokesGainedOffTheTee: ?any,
        +strokesGainedPutting: ?any,
        +strokesGainedShortGame: ?any,
        +strokesGainedTeeToGreen: ?any,
        +strokesGainedTotal: ?any,
        +goodDriveRatio: ?any,
        +currentPosition: ?string,
        +dkScore: ?any,
        +eventToPar: ?number,
        +event: {|
          +startDate: any,
          +shortEndDate: ?string,
          +tournament: {|
            +officialName: string
          |},
        |},
      |}
    |}>
  |},
  +$refType: PGARecentHistoryTable_query$ref,
|};
export type PGARecentHistoryTable_query$data = PGARecentHistoryTable_query;
export type PGARecentHistoryTable_query$key = {
  +$data?: PGARecentHistoryTable_query$data,
  +$fragmentRefs: PGARecentHistoryTable_query$ref,
  ...
};
*/


const node/*: ReaderFragment*/ = (function(){
var v0 = [
  "pgaRecentHistoryForDkPlayer"
];
return {
  "argumentDefinitions": [
    {
      "defaultValue": 10,
      "kind": "LocalArgument",
      "name": "count"
    },
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "cursor"
    },
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "playerId"
    }
  ],
  "kind": "Fragment",
  "metadata": {
    "connection": [
      {
        "count": "count",
        "cursor": "cursor",
        "direction": "forward",
        "path": (v0/*: any*/)
      }
    ],
    "refetch": {
      "connection": {
        "forward": {
          "count": "count",
          "cursor": "cursor"
        },
        "backward": null,
        "path": (v0/*: any*/)
      },
      "fragmentPathInResult": [],
      "operation": require('./PGARecentHistoryTablePaginationQuery.graphql.js')
    }
  },
  "name": "PGARecentHistoryTable_query",
  "selections": [
    {
      "alias": "pgaRecentHistoryForDkPlayer",
      "args": [
        {
          "kind": "Variable",
          "name": "dkPlayerId",
          "variableName": "playerId"
        }
      ],
      "concreteType": "PGATourEventPlayerTypeConnection",
      "kind": "LinkedField",
      "name": "__PGARecentHistoryTable_pgaRecentHistoryForDkPlayer_connection",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "PGATourEventPlayerTypeEdge",
          "kind": "LinkedField",
          "name": "edges",
          "plural": true,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "PGATourEventPlayerType",
              "kind": "LinkedField",
              "name": "node",
              "plural": false,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "id",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "strokesGainedApproachTheGreen",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "strokesGainedAroundTheGreen",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "strokesGainedBallStriking",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "strokesGainedIronPlay",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "strokesGainedOffTheTee",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "strokesGainedPutting",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "strokesGainedShortGame",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "strokesGainedTeeToGreen",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "strokesGainedTotal",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "goodDriveRatio",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "currentPosition",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "dkScore",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "eventToPar",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "PGATourEventType",
                  "kind": "LinkedField",
                  "name": "event",
                  "plural": false,
                  "selections": [
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "startDate",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "shortEndDate",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "concreteType": "PGATourTournamentType",
                      "kind": "LinkedField",
                      "name": "tournament",
                      "plural": false,
                      "selections": [
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "officialName",
                          "storageKey": null
                        }
                      ],
                      "storageKey": null
                    }
                  ],
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "__typename",
                  "storageKey": null
                }
              ],
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "cursor",
              "storageKey": null
            }
          ],
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "PageInfo",
          "kind": "LinkedField",
          "name": "pageInfo",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "endCursor",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "hasNextPage",
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Query",
  "abstractKey": null
};
})();
// prettier-ignore
(node/*: any*/).hash = '16e4445ab7193e44eaf5e1003c18ea68';

module.exports = node;
